import React from 'react'
import PropTypes from 'prop-types'

import { CreditCardIframe } from './CreditCardIframe'
import { getRestaurantShortUrl } from '../../api/util'

const getIframeSrc = ({ amexAccepted }) => {
  const iframeSrc =
    process.env.CREDIT_CARD_IFRAME_URI ||
    `${
      window.location.origin
    }/${getRestaurantShortUrl()}/v3/ccform?color=%23002182`
  const iframeUrl = new URL(iframeSrc)

  if (amexAccepted) {
    iframeUrl.searchParams.set('amexAccepted', 'true')
  }

  return iframeUrl.toString()
}

export const CreditCard = ({ amexAccepted, field, form }) => {
  const onChange = (data) => {
    form.setFieldValue(field.name, data)
    form.setFieldTouched(field.name, true)
  }

  const iframeSrc = getIframeSrc({
    amexAccepted
  })

  return (
    <CreditCardIframe src={iframeSrc} onChange={(data) => onChange(data)} />
  )
}

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired
})

const FormShape = PropTypes.shape({
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
})

CreditCard.defaultValues = {
  amexAccepted: false
}

CreditCard.propTypes = {
  amexAccepted: PropTypes.bool,
  field: FieldShape.isRequired,
  form: FormShape.isRequired
}
